import React, { useEffect } from "react";
import "./LandingScreen.css";
import { useDispatch, useSelector } from "react-redux";
import { listProjects } from "../actions/projectActions";
import { Link } from "react-router-dom";

const HomeScreen = () => {
  const dispatch = useDispatch();

  // Grab projects from Redux state
  const projectList = useSelector((state) => state.projectList);
  const { loading, error, projects } = projectList;

  // Grab user info to ensure they are developer or admin
  const { userInfo } = useSelector((state) => state.userLogin);

  useEffect(() => {
    if (userInfo) {
      dispatch(listProjects());
    }
  }, [dispatch, userInfo]);

  return (
    <div className="landing-container">
      <div className="section">
        <h2>Welcome to REDrones Project Dashboard</h2>
        <p>
          Here you’ll find detailed updates, project insights, and
          drone-captured imagery to track your real estate development progress.
        </p>
      </div>
      <div className="section services">
        <h2>Project Portfolio</h2>
        <p>
          Access your portfolio of active and past developments. Click on a
          project to view images, timelines, and performance metrics.
        </p>
        <p>Click your project below:</p>
        {loading && <p>Loading projects...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
        {!loading && !error && projects && projects.length > 0 ? (
          <ul>
            {projects.map((project) => (
              <li key={project._id}>
                {/* Adjust the path if DevelopmentScreen is at /posts/:id or /development/:id */}
                <Link to={`/posts/${project._id}`}>{project.name}</Link>
              </li>
            ))}
          </ul>
        ) : (
          !loading &&
          !error && (
            <p>You currently have no projects. Create one to get started.</p>
          )
        )}
      </div>
      <div className="section info">
        <h2>Stay Informed</h2>
        <p>
          We’ll continue to update this platform with new features, analytics
          tools, and integration options. Thank you for choosing REDrones.
        </p>
      </div>
    </div>
  );
};

export default HomeScreen;
